import jwtDecode from "jwt-decode";

const setSession = (
  accessToken: string | null,
  userData: Object | null = null
) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    if (userData) localStorage.setItem("userData", JSON.stringify(userData));
    //axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    //delete axios.defaults.headers.common.Authorization;
  }
};

const isValidToken = (accessToken: string) => {
  if (!accessToken) return false;

  const decodedToken = jwtDecode<{ exp: number }>(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

export { isValidToken, setSession };
